import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ativarDataHojeDuploClique } from './utils/dataHojeDuploClique'

ativarDataHojeDuploClique()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
